module.exports = __webpack_public_path__ + "static/media/435_Closet2.04fc6772.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/435_Closet2.jpg
// module id = 558
// module chunks = 0